import { useMemo, useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { daysDiffernce, showPrice } from "../../utils/utils";
import { useForm } from "react-hook-form";
import DatePicker from "react-datepicker";
import services from "@api/services";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import moment from "moment";
import { toast } from "react-toastify";
import { getTaxService } from "../../api/services/newServices";
import { FaLongArrowAltRight } from "react-icons/fa";
import { FaBed } from "react-icons/fa";
import { IoFastFoodSharp } from "react-icons/io5";
import Select from "react-select";

const REMARKS_KEY = [
    "Booking.com",
    "Agoda",
    "Cleartrip",
    "MMT",
    "Go - Ibibo",
    "Fab",
    "Treebo",
    "Brevistay",
    "OYO",
];

const FOOD_PLAN = {
    0: 'EP',
    1: 'CP',
    2: 'AP',
    3: 'MAP',
};

const TRAVEL_TYPE = [
    { id: 1, name: 'Business Travel' },
    { id: 2, name: 'Couple Friendly' },
    { id: 3, name: 'Family Vacation' },
    { id: 4, name: 'Group Travel' },
    { id: 5, name: 'Solo Travel' },
]

export const mobileRegex = /^[6789]\d{9}$/i;

const BOOKING_TEXT = ["upcoming", "inHouse", "complete", "All"];

const PAYMENT_MODES = {
    PAYLATER: 6,
    CASH: 2,
    CARD: 3,
    FOC: 4,
    UPI: 5,
    PAYLATER: 6,
    PREPAID: 7,
};

const meal_Modes = {
    ep: 0,
    breakFastPrice: 1,
    ap: 2,
    map: 3,
};

const CreateTABooking = () => {
    const { register, handleSubmit, setValue, reset, watch, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const todayMoment = moment();

    const tomorrowMoment = todayMoment.clone().add(1, "days");
    const yesterDay = new Date();
    yesterDay.setDate(yesterDay.getDate() - 1);

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const [tax, setTax] = useState({});
    const { access_token, taDetails } = useSelector(authenticationSeletor);
    const [tableData, setTableData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [source, setSource] = useState("TA");
    const [sourceText, setSourceText] = useState("");
    const [roomPrice, setRoomPrice] = useState(0);
    const [btnDisable, setBtnDisable] = useState(false)
    const [roomAvil, setRoomAvil] = useState(null)
    const [roomCountData, setRoomCountData] = useState([]);
    const [mealPlan, setMealPlan] = useState("ep");
    const [dateRange, setDateRange] = useState([new Date(), tomorrow]);
    const [checkinDate, checkOutDate] = dateRange || [];
    const [roomCate, setRoomCate] = useState([]);
    const [allPro, setAllPro] = useState([])
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [zones, setZones] = useState([])
    const [states, setStates] = useState([])
    const [hubs, setHubs] = useState([])
    const [cities, setCities] = useState([])
    const [localityData, setLocalityData] = useState([]);
    const [mode, setMode] = useState('commission')

    const [bookingData, setBookingData] = useState({ room: 1, adults: 1, children: 0 });

    const { zone, state, hub, city, Locality, selectProperty, selectRoomType, newPrices, primaryGuestName } = watch();

    const mealPlanHandler = (value) => {
        const roomId = watch().selectRoomType?.split(",")[0];
        if (roomId) {
            if (mealPlan == value) {
                setMealPlan("ep");
            } else {
                setMealPlan(value);
            }
        } else {
            toast.error("Please Select Room Type*", {
                autoClose: 1000,
                pauseOnHover: true,
                position: "top-right",
            });
        }
    };

    const getTaxApi = async () => {
        try {
            const res = await getTaxService();
            if (res) { setTax(res) }
        } catch (error) { console.log("error in getTaxApi function.") }
    };


    const getRoomCount = async () => {
        const res = await services?.property?.roomOccupancyForTodayService(selectedProperty?.id);
        if (res) { setRoomCountData(res?.data?.data) }
    };

    const roomCategoryDrop = async () => {
        try {
            const res = await services.property.getRoomCategoryService();
            if (res.status == 200) { setCategories(res.data?.data) }
        } catch (error) { console.log("error in roomCategoryDrop function.") }
    };

    const getRoomCategory = async (id) => {
        if (!id) { return; }
        try {
            const res = await services.globalService.getRoomByPropertyIdService(id);
            if (res.status == 200) { setTableData(res.data.data) }
        } catch (error) { console.log("error in getRoomCategory function.") }
    };

    useEffect(() => { getRoomCategory(selectedProperty?.id); roomCategoryDrop() }, [selectedProperty])

    useEffect(() => { getRoomCount(); getTaxApi() }, [])

    useMemo(() => {
        const room = bookingData.room;
        const day = Math.max(daysDiffernce(checkinDate, checkOutDate), 1);
        const roomWithTax = Number(roomPrice) + (Number(roomPrice) * tax?.amount) / 100;
        const final = Math.round(roomWithTax) * room * day;
        if (mealPlan !== "ep") {
            const roomId = watch().selectRoomType?.split(",")[0];
            const roomForPrice = tableData.find((i) => i.categoryId == roomId);
            if (mealPlan) {
                setValue("newPrices", final + roomForPrice[mealPlan] * Number(bookingData.adults));
            }
        } else {
            setValue("newPrices", final);
        }
    }, [roomPrice, bookingData, checkinDate, checkOutDate, mealPlan]);


    const [bookingDetails, setBookingDetails] = useState(null)

    const getSingleBooking = async (bookingId) => {
        try {
            const res = await services.globalService.getSingleBookingDetail(bookingId);
            if (res.status == 200) { setBookingDetails(res?.data?.data) }
        } catch (error) { console.log("error in getSingleBooking function.") }
    };

    const [companyPopup, setCompanyPopup] = useState(false);

    const [localOutstation, setLocalOutstation] = useState(false);

    // console.log('mealPlan', mealPlan)

    const submitHandler = async (payload) => {
        const realPayload = {
            taCode: taDetails?.taCode,
            fromDate: moment(checkinDate).format("YYYY-MM-DD"),
            toDate: moment(checkOutDate).format("YYYY-MM-DD"),
            noOfRooms: bookingData.room,
            adults: bookingData.adults,
            children: bookingData.children,
            breakFast: meal_Modes[payload.mealPlan],
            createdBy: taDetails?.id,
            zone: zones?.find((item) => item?.id == zone)?.name,
            state: states?.find((item) => item?.id == state)?.name,
            city: cities?.find((item) => item?.id == city)?.name,
            locality: Locality,
            roomType: payload.roomType
        };
        if (mode == 'commission') {
            realPayload.commissionPercentage = taDetails?.commission
        }
        else {
            realPayload.commissionPerRoom = payload?.markupValue
        }
        setBtnDisable(true)
        try {
            let res = {};
            res = await services.property.taBookingEnqueryService(realPayload);
            if (res.status == 200) {
                setBtnDisable(true)
                setLocalOutstation(false)
                navigate('/ta-profile')
            }
        } catch (error) { console.log("error in submitHandler function.") }
        finally { setBtnDisable(false) }
    };

    const handleChange = (field, dir, minVal = 1) => {
        if (dir == "up") {
            setBookingData({ ...bookingData, [field]: Number(bookingData[field] + 1) });
        } else {
            if (bookingData[field] > minVal) {
                setBookingData({ ...bookingData, [field]: Number(bookingData[field] - 1) });
            }
        }
    };

    const changeHandler = (e) => {
        setRoomPrice(() => e.target.value?.split(",")[1]);
        const room = bookingData.room;
        const day = daysDiffernce(checkinDate, checkOutDate);
        const roomWithTax = Number(roomPrice) + (Number(roomPrice) * tax?.amount) / 100;
        const final = Math.round(roomWithTax) * room * day;
        setValue("newPrices", final?.toString());
        const selectedCategory = roomCountData?.find((item) => item?.categoryId == e.target.value?.split(',')[0])
        if (bookingData.room >= selectedCategory?.availableCount) {
            setRoomAvil(selectedCategory?.availableCount)
        }
        else { setRoomAvil(selectedCategory?.availableCount) }
    };

    useEffect(() => { setBookingData({ ...bookingData, room: 1 }) }, [selectRoomType])

    const fetchZones = async () => {
        try {
            const res = await services.property.allZoneService()
            if (res.data.status == true) { setZones(res.data.data) }
        }
        catch { console.log("error in fetchZones function.") }
    }

    useEffect(() => { fetchZones() }, [])

    const fetchStateByZone = async () => {
        try {
            const res = await services.property.getStateByZone(zone)
            if (res.data.status == true) { setStates(res.data.data) }
        }
        catch { console.log("error in fetchStateByZone function.") }
    }

    useEffect(() => { if (zone) { fetchStateByZone(zone) } }, [zone])

    const fetchHubByState = async () => {
        try {
            const res = await services.property.getHubByState(state)
            if (res.data.status == true) { setHubs(res.data.data.Hubs) }
        }
        catch { console.log("error in fetchHubByState function.") }
    }

    useEffect(() => { if (state) { fetchHubByState(state) } }, [state])

    const fetchCityByHub = async () => {
        try {
            const res = await services.property.getCityByHub(hub)
            if (res.data.status == true) { setCities(res.data.data) }
        }
        catch { console.log("error in fetchCityByHub function.") }
    }

    useEffect(() => { if (state) { fetchCityByHub(hub) } }, [hub])

    const getLocality = async (id) => {
        try {
            const locality = await services.globalService.getLocalityByCity(id);
            if (locality.status == 200) { setLocalityData(locality.data.data); }
        } catch (error) { console.log("error in getLocality function.") }
    };

    useEffect(() => { if (city) { getLocality(city); } }, [city]);

    const fetchProperties = async () => {
        let zoneName = zones?.find((item) => item?.id == zone)?.name
        try {
            const param = `?countryId=IN&zone=${zoneName}&stateId=${state}&hub=${hub}&cityId=${city}`
            const res = await services.property.getPropertyByArea(zoneName ? param : '')
            if (res.data.status == true) { setAllPro(res?.data?.data) }
        }
        catch { console.log("error in fetchProperties function.") }
    }

    useEffect(() => { fetchProperties() }, [city])

    useEffect(() => {
        let singleProperty = allPro?.find((data) => data?.id == selectProperty)?.Rooms
        setRoomCate(singleProperty)
    }, [selectProperty])

    return (
        <div className="section booking-page">
            <div className="container">
                <div className="booking-wrapper">
                    <div className="booking-tab">
                        <ul>
                            <li
                                className={mode == 'commission' ? 'active' : ''}
                                onClick={() => setMode('commission')}>
                                Commission Base Booking
                            </li>
                            <li
                                className={mode == 'markup' ? 'active' : ''}
                                onClick={() => setMode('markup')}>
                                Booking with markup
                            </li>
                        </ul>
                    </div>
                    <h2>Create TA Booking</h2>
                    <div className="row">
                        <div className='col-lg-2 col-md-6 col-sm-6 gap-mb-sm-2'>
                            <select
                                className="form-control"
                                {...register("zone")}
                            >
                                <option value="">Select Zone</option>
                                {zones?.map((item) => (
                                    <option key={item.id} value={item?.id}>
                                        {item?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-2 col-md-6 col-sm-6 gap-mb-sm-2'>
                            <select
                                className="form-control"
                                {...register("state")}
                            >
                                <option value="">Select State</option>
                                {states?.map((item) => (
                                    <option key={item.id} value={item?.id}>
                                        {item?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-2 col-md-6 col-sm-6 gap-mb-sm-2'>
                            <select
                                className="form-control"
                                {...register("hub")}
                            >
                                <option value="">Select Hub</option>
                                {hubs?.map((item) => (
                                    <option key={item.id} value={item?.id}>
                                        {item?.hubname}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-2 col-md-6 col-sm-6 gap-mb-sm-2'>
                            <select
                                className="form-control"
                                {...register("city")}
                            >
                                <option value="">Select City</option>
                                {cities?.map((item) => (
                                    <option key={item.id} value={item?.id}>
                                        {item?.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className='col-lg-4 gap-mb-sm-2'>
                            <select
                                className="form-control"
                                {...register("Locality", {
                                    required: "Locality is required",
                                })}
                                defaultValue=""
                            >
                                <option value="" disabled>
                                    Select Locality
                                </option>
                                {localityData.map((innerData, index) => (
                                    <option key={index} value={innerData.name}>
                                        {innerData.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <p className="text-danger mt-2 border-bottom pb-4">* You must select a Locality before you can submit the form.</p>
                    <form
                        className="popup-form onboardForm instock"
                        onSubmit={handleSubmit(submitHandler)}
                    >
                        <div className="booking-form-box">
                            <div className="left">
                                <div className="row">
                                    <div className="col-lg-12"><h5>Stay Details</h5></div>
                                    <div className="col-lg-6">
                                        <label>Check In | Check Out ({daysDiffernce(checkinDate, checkOutDate)} Night)<small className="text-danger fw-bold fs-6">*</small></label>
                                        <DatePicker
                                            className="form-control"
                                            selectsRange={true}
                                            startDate={checkinDate}
                                            endDate={checkOutDate}
                                            onChange={(update) => {
                                                setDateRange(update);
                                            }}
                                            dateFormat="dd/MM/yyyy"
                                            minDate={new Date()}
                                            isClearable={true}
                                        />
                                    </div>
                                    <div className="col-lg-6">
                                        <label>Select Room Type</label>
                                        <select
                                            className="form-control"
                                            {...register("roomType", {
                                                required: "Room Type is required",
                                            })}
                                            defaultValue=""
                                        >
                                            <option value="" disabled>Select Room Type</option>

                                            {
                                                categories?.map((item) => {
                                                    return (
                                                        <option key={item?.id} value={item?.name}>{item?.name}</option>
                                                    )
                                                })
                                            }
                                        </select>

                                        {errors?.roomType && (
                                            <small style={{ color: "red" }}>
                                                {errors.roomType.message}
                                            </small>
                                        )}
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="flex">
                                            <div>
                                                <label>Rooms<small className="text-danger fw-bold fs-6">*</small></label>
                                                <div className="BtnsWrapBoth">
                                                    <button
                                                        type="button"
                                                        className="BtnDown"
                                                        onClick={() => handleChange("room", "down")}
                                                    >
                                                        -
                                                    </button>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="room"
                                                        value={bookingData.room}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="BtnUp"
                                                        onClick={() => handleChange("room", "up")}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="ml-2 mr-2">
                                                <label>Adults<small className="text-danger fw-bold fs-6">*</small></label>
                                                <div className="BtnsWrapBoth">
                                                    <button
                                                        type="button"
                                                        className="BtnDown"
                                                        onClick={() => handleChange("adults", "down")}
                                                    >
                                                        -
                                                    </button>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="adults"
                                                        value={bookingData.adults}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="BtnUp"
                                                        onClick={() => handleChange("adults", "up")}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                            <div>
                                                <label title="(Age below 9 Years Only)">Child<small className="text-danger fw-bold fs-6 opacity-0">*</small></label>
                                                <div className="BtnsWrapBoth">
                                                    <button
                                                        type="button"
                                                        className="BtnDown"
                                                        onClick={() => handleChange("children", "down", 0)}
                                                    >
                                                        -
                                                    </button>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        name="children"
                                                        value={bookingData.children}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="BtnUp"
                                                        onClick={() => handleChange("children", "up", 0)}
                                                    >
                                                        +
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            roomAvil != null && (
                                                <div className={`position-absolute ${roomAvil == 0 ? "text-danger fs-8" : "text-success fs-8"}`}>
                                                    {roomAvil == 0
                                                        ? `${roomAvil} room available`
                                                        : `${roomAvil} ${roomAvil > 1 ? 'rooms' : 'room'} available`}
                                                </div>
                                            )
                                        }
                                    </div>
                                    <div className="col-lg-6">
                                        <label>Meal Plan<small className="text-danger fw-bold fs-6 opacity-0">*</small></label>
                                        <div className="field-with-icon">
                                            <select {...register("mealPlan")} className="form-control">
                                                <option value={'ep'}>EP - (Room Only)</option>
                                                <option value={'breakFastPrice'}>CP - (With BreakFast)</option>
                                                <option value={'map'}>MAP - (Meal + BreakFast)</option>
                                                <option value={'ap'}>AP - (All Meal)</option>
                                            </select>
                                            <span className="icon"><IoFastFoodSharp size={18} /></span>
                                        </div>
                                    </div>
                                    {
                                        mode == 'markup' && (
                                            <div className="col-lg-6">
                                                <label>Markup Value</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    {...register("markupValue", {
                                                        required: "Markup Value is required",
                                                    })}
                                                    placeholder="Enter Markup Value"
                                                />

                                                {errors.markupValue && (
                                                    <small style={{ color: "red" }}>{errors.markupValue.message}</small>
                                                )}
                                            </div>
                                        )
                                    }
                                    <div className="col-lg-12 mt-3">
                                        <div className="text-right">
                                            <button type="submit" className="btn btn-primary" disabled={btnDisable}>
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateTABooking;
